module.exports = __webpack_public_path__ + "img/129.f096760c.png";